import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { update } from '@/routes/profile';
import { SharedData } from '@/types';
import { router, usePage } from '@inertiajs/react';
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
    const { props } = usePage<SharedData & { locale: string }>();
    const currentLocale = props.auth?.user?.locale || props.locale || 'en';

    const handleLanguageChange = (locale: string) => {
        if (props.auth?.user) {
            router.patch(update().url, {
                locale,
                name: props.auth.user.name,
                email: props.auth.user.email
            });
        } else {
            router.get(window.location.pathname, { locale }, { preserveState: false });
        }
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="h-9 w-9 rounded-full">
                    <Globe className="h-[1.2rem] w-[1.2rem]" />
                    <span className="sr-only">Toggle language</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => handleLanguageChange('en')}>
                    <span className={currentLocale === 'en' ? 'font-bold' : ''}>English</span>
                    {currentLocale === 'en' && <span className="ml-auto text-xs">✓</span>}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => handleLanguageChange('ta')}>
                    <span className={currentLocale === 'ta' ? 'font-bold' : ''}>தமிழ் (Tamil)</span>
                    {currentLocale === 'ta' && <span className="ml-auto text-xs">✓</span>}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
